import { render } from "./KnowledgeConfiguration.vue?vue&type=template&id=1ca646c2&scoped=true"
import script from "./KnowledgeConfiguration.vue?vue&type=script&lang=js"
export * from "./KnowledgeConfiguration.vue?vue&type=script&lang=js"

import "./KnowledgeConfiguration.vue?vue&type=style&index=0&id=1ca646c2&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebasedevdemo\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca646c2"]])

export default __exports__